import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { log } from 'log';

import * as actions from '../store/actions';
import { LIVE_GAME_IMAGE_UPDATE_INTERVAL } from '../constants';

export const useLiveGamesOnSocketOpen = () => {
    const dispatch = useDispatch();

    return useCallback((): void => {
        dispatch(actions.updateConnectionStatus(true));
        dispatch(actions.updateIsNeedToStart(false));
        dispatch(actions.updateLiveGamesImagesTimestamp());

        log('log', '[LIVE | Portal] WebSocket connection opened');

        const liveGamesIntervalId = window.setInterval(() => {
            dispatch(actions.updateLiveGamesImagesTimestamp());
        }, LIVE_GAME_IMAGE_UPDATE_INTERVAL);

        dispatch(actions.updateLiveGamesImagesIntervalId(liveGamesIntervalId));
    }, [dispatch]);
};
